import { AxiosInstance } from 'axios'

export type ServiceCategoriesDto = {
  data: ServiceCategoriesItemDto[]
}
export type ServiceCategoriesItemDto = {
  id: number
  attributes: {
    name: string
    slug: string
    parent_category: {
      data: ServiceCategoriesItemDto | null
    }
  }
}

export type GetMainServiceCategoryArgs = {
  locale: string
}

export const getMainServiceCategories = async (client: AxiosInstance, { locale }: GetMainServiceCategoryArgs) => {
  const path = `/service-categories`
  const params = {
    locale,
    fields: ['name', 'slug'],
    populate: {
      parent_category: {
        fields: ['name', 'slug'],
      },
    },
  }
  return (await client.get<ServiceCategoriesDto>(path, { params })).data.data.filter(
    c => !c.attributes.parent_category.data,
  )
}
